import script from "./GlobalVisitCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalVisitCounter.vue?vue&type=script&setup=true&lang=js"

import "./GlobalVisitCounter.vue?vue&type=style&index=0&id=48e314be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e314be"]])

export default __exports__